const data = {
  bankingInformation: [
    {
      companyName: "Taram Inc",
      country: "USA",
      address: "135 Santa Barbara, Irvine, CA - 92606, USA",
      banks: [
        { bankName: "Chase Bank", accountNumber: "3" },
        // { bankName: "Mercury Bank", accountNumber: "" }
      ],
    },
    {
      companyName: "Taram Supply Chain Private Limited",
      country: "India",
      address:
        "170-D Madasam Koil Street, Rajapalayam - 626117, Tamil Nadu, India",
      banks: [{ bankName: "Bank of Baroda", accountNumber: "2" }],
    },
    {
      companyName: "Taram Czech s.r.o",
      country: "Czechia",
      address: "27/93 Sokolvska, Karlin, Prague - 18600, Czechia",
      banks: [{ bankName: "Air Bank", accountNumber: "0" }],
    },
  ],
};

const AdminAccountOverview = () => {
  return (
    <section className="card my-8">
      <div className="flex flex-col">
        <div className="items-center justify-between gap-3 sm:flex">
          <h2 className="text-lg font-semibold text-gray-800">
            Banking Information
          </h2>
          <div className="relative">
            <input
              type="text"
              placeholder="Search"
              className="w-64 rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
              onChange={(e) => {
                const val = e.target.value.toLowerCase();
                const rows =
                  document.querySelectorAll<HTMLTableRowElement>(
                    "tbody tr[data-row]"
                  );
                rows.forEach((row) => {
                  const haystack = row.dataset.search || "";
                  row.style.display = haystack.includes(val) ? "" : "none";
                });
              }}
            />
          </div>
        </div>

        <div className="mt-4 overflow-x-auto">
          <div className="inline-block min-w-full align-middle">
            <div className="overflow-hidden rounded-lg border border-gray-200">
              <table className="min-w-full table-auto text-left">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="p-4 text-sm font-semibold text-gray-700">
                      Company Name
                    </th>
                    <th className="p-4 text-sm font-semibold text-gray-700">
                      Country
                    </th>
                    <th className="p-4 text-sm font-semibold text-gray-700">
                      Address
                    </th>
                    <th className="p-4 text-sm font-semibold text-gray-700">
                      Bank Name
                    </th>
                    <th className="p-4 text-sm font-semibold text-gray-700">
                      Account Number
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {data.bankingInformation.flatMap((row, idx) => {
                    const bankRows =
                      row.banks.length > 0
                        ? row.banks
                        : [{ bankName: "", accountNumber: "" }];
                    return bankRows.map((b, j) => {
                      const first = j === 0;
                      const searchBlob = [
                        row.companyName,
                        row.country,
                        row.address,
                        b.bankName,
                        b.accountNumber,
                      ]
                        .join(" ")
                        .toLowerCase();

                      return (
                        <tr
                          key={`${idx}-${j}`}
                          data-row
                          data-search={searchBlob}
                          className="odd:bg-white even:bg-gray-50"
                        >
                          <td className="whitespace-pre-wrap p-4 align-top text-sm text-gray-900">
                            {first ? row.companyName : ""}
                          </td>
                          <td className="whitespace-pre-wrap p-4 align-top text-sm text-gray-700">
                            {first ? row.country : ""}
                          </td>
                          <td className="whitespace-pre-wrap p-4 align-top text-sm text-gray-700">
                            {first ? row.address : ""}
                          </td>
                          <td className="p-4 text-sm text-gray-900">
                            {b.bankName}
                          </td>
                          <td className="p-4 text-sm text-gray-900">
                            {b.accountNumber || "-"}
                          </td>
                        </tr>
                      );
                    });
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminAccountOverview;
